const config = {
  baseUrl: 'https://catalog-ingest.dev.funimationsvc.com/',
  apiKey: 'A8bf7HeA5u8ZxVQIe39F94uNBBgrldVpaE3qVd8M',
  asset: 'v1/asset/:prefix?LastEvaluatedKey=',
  availability: 'v1/availability/:prefix?LastEvaluatedKey=',
  package: 'v1/package/:prefix?LastEvaluatedKey=',
  title: 'v1/title/:prefix?LastEvaluatedKey=',
};
export default config;
